import { LogLevel } from "@azure/msal-browser";

 export const msalConfig = {
     auth: {
         clientId: '3a202ce2-4572-4b98-a8aa-3661d3093ba9',//'8f845d63-c5d2-4105-94a9-db6683954a5d', // This is the ONLY mandatory field that you need to supply.
         authority: 'https://login.microsoftonline.com/2cd7132f-cbba-4b58-884c-966791b8ab2b',//'https://login.microsoftonline.com/23f09e4a-dfdd-4053-b446-6a0dba63cead', 
        //  redirectUri: 'http://localhost:3000/',
        //  postLogoutRedirectUri: 'http://localhost:3000/',
         redirectUri: 'https://www.wwf-projecttracker.in/', 
         postLogoutRedirectUri: 'https://www.wwf-projecttracker.in/',
         navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
     },
     cache: {
         cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
         storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
     },
     system: {
         loggerOptions: {
             loggerCallback: (level, message, containsPii) => {
                 if (containsPii) {
                     return;
                 }
                 switch (level) {
                     case LogLevel.Error:
                         console.error(message);
                         return;
                     case LogLevel.Info:
                         console.info(message);
                         return;
                     case LogLevel.Verbose:
                         console.debug(message);
                         return;
                     case LogLevel.Warning:
                         console.warn(message);
                         return;
                     default:
                         return;
                 }
             },
         },
     },
 };

 
 export const loginRequest = {
     scopes: ["openid", "profile",
        "api://87806d47-b9aa-4e57-a033-d5692247f1e2/expenseTrackerAccess"]
 };

 
    export const silentRequest = {
      scopes: ["api://87806d47-b9aa-4e57-a033-d5692247f1e2/expenseTrackerAccess"
    ]
     
    };

